export default `
  mutation deleteAiAttachmentFile($projectId: String!, $key: String!) {
    deleteAiAttachmentFile(projectId: $projectId, key: $key) {
      key
      deleted
    }
  }
`
